jQuery(document).ready(jobsInit);

function jobsInit(){
	
	setupSearchDropdowns();
	setupClickableRows();
	setupCollapsibleContent();
	
}

function setupSearchDropdowns() {
	
	jQuery('.job-load-terms').on('change', function(){
		
		var current = jQuery(this);
		var parentTerm = current.val();
		var tax = current.attr('data-tax');
		
		if(!parentTerm) return false;
		
		current.addClass('loading');
		
		jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=get_terms_for_dropdown&parentTerm='+ parentTerm + '&tax=' + tax,
			success:function(results){

				if(tax == 'certification') {
					var targetDropdownTax = "specialty";
				} else if(tax == 'location') {
					var targetDropdownTax = "city";
				}
				
				var targetDropdown = jQuery('select[data-tax="' + targetDropdownTax + '"]');
				var placeholderOption = jQuery('option:eq(0)', targetDropdown);
				
				targetDropdown.html(placeholderOption).append(results);
				targetDropdown.parents('li').removeClass('disabled');
				
				current.removeClass('loading');
				
			}
		});
		
	});
	
	jQuery('.change-job-count').on('change', function(){
		
		var current = jQuery(this);
		var count = current.val();
		
		jQuery('#job-count').val(count);
		jQuery('#job-search').submit();
		
	});
	
}

function setupClickableRows() {
	
	jQuery('table.jobs tbody tr').on('click', function(){
		
		var current = jQuery(this);
		var href = jQuery('td:first-child a', current).attr('href');
		
		window.location = href;
		
	});
	
}

function setupCollapsibleContent() {
	
	jQuery('#view-more').on('click', function(){
		
		jQuery('#collapsible-job-content').slideToggle(500);
		jQuery(this).toggleClass('open');
		
	});
	
}
